import { jsx as _jsx } from "react/jsx-runtime";
import { ClampedTypography } from "../../../Typographies/ClampedTypography";
import { useMediaQuery, useTheme } from "@mui/material";
/**
 * Displays a title with responsive typography based on screen size.
 * For mobile screens, it uses a smaller typography component with a maximum of 1 line.
 * For larger screens, a larger typography component is used with up to 2 lines.
 *
 * @param {string} title - The title text to display.
 */
export const TitleDisplay = ({ title }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(ClampedTypography, Object.assign({ variant: "h4", color: "primary", align: "left", lines: isMobile ? 1 : 2 }, { children: title })));
};
